import { combineReducers } from 'redux';
import { configuratorReducer } from '@gcc/configurator';
import getConfig from './config';
import thdStoreInfo from './thdStoreInfo';
import { measures } from './measure';
import summaryDrawer from './summaryDrawer';
import steps from './steps';
import { pricing } from './pricing';
import { mandiMore } from './mandiMore';
import design from './design';
import canonicalUrl from './canonicalUrl';
import store from './store';
import { carpetPad } from './carpetPad';
import skuData from './skuData';
import selections from './selections';
import availableChoices from './availableChoices';
import errorsOnPage from './errorsOnPage';

let rootReducerInstance = null;

const getRootReducer = () => {
  if (!rootReducerInstance) {
    const config = getConfig();
    rootReducerInstance = combineReducers({
      configurator: configuratorReducer,
      config,
      thdStoreInfo,
      measures,
      steps,
      summaryDrawer,
      pricing,
      mandiMore,
      design,
      canonicalUrl,
      store,
      carpetPad,
      skuData,
      selections,
      availableChoices,
      errorsOnPage
    });
  }
  return rootReducerInstance;
};

export default getRootReducer;
